import { SVGProps } from "react"
const BackIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="30"
      y="30"
      width="30"
      height="30"
      rx="15"
      transform="rotate(-180 30 30)"
      fill="#F7F7F7"
    />
    <path
      d="M18.7416 15.4807L12.9464 21.0071C12.667 21.2737 12.2138 21.2737 11.9344 21.0071L11.2584 20.3626C10.9794 20.0965 10.9789 19.6652 11.2573 19.3985L15.85 14.9981L11.2573 10.5976C10.9789 10.3309 10.9794 9.89962 11.2584 9.63352L11.9344 8.98895C12.2138 8.72243 12.6669 8.72243 12.9464 8.98895L18.7416 14.5155C19.021 14.782 19.021 15.2141 18.7416 15.4807Z"
      fill="black"
    />
    <path
      d="M18.7416 15.4807L12.9464 21.0071C12.667 21.2737 12.2138 21.2737 11.9344 21.0071L11.2584 20.3626C10.9794 20.0965 10.9789 19.6652 11.2573 19.3985L15.85 14.9981L11.2573 10.5976C10.9789 10.3309 10.9794 9.89962 11.2584 9.63352L11.9344 8.98895C12.2138 8.72243 12.6669 8.72243 12.9464 8.98895L18.7416 14.5155C19.021 14.782 19.021 15.2141 18.7416 15.4807Z"
      fill="black"
      fillOpacity="0.2"
    />
    <path
      d="M18.7416 15.4807L12.9464 21.0071C12.667 21.2737 12.2138 21.2737 11.9344 21.0071L11.2584 20.3626C10.9794 20.0965 10.9789 19.6652 11.2573 19.3985L15.85 14.9981L11.2573 10.5976C10.9789 10.3309 10.9794 9.89962 11.2584 9.63352L11.9344 8.98895C12.2138 8.72243 12.6669 8.72243 12.9464 8.98895L18.7416 14.5155C19.021 14.782 19.021 15.2141 18.7416 15.4807Z"
      fill="black"
      fillOpacity="0.2"
    />
    <path
      d="M18.7416 15.4807L12.9464 21.0071C12.667 21.2737 12.2138 21.2737 11.9344 21.0071L11.2584 20.3626C10.9794 20.0965 10.9789 19.6652 11.2573 19.3985L15.85 14.9981L11.2573 10.5976C10.9789 10.3309 10.9794 9.89962 11.2584 9.63352L11.9344 8.98895C12.2138 8.72243 12.6669 8.72243 12.9464 8.98895L18.7416 14.5155C19.021 14.782 19.021 15.2141 18.7416 15.4807Z"
      fill="black"
      fillOpacity="0.2"
    />
  </svg>
)
export default BackIcon
